import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { DeliveryRequest } from 'src/models/deliveryRequest.model';
import { CodebookService } from 'src/services/codebook.service';
import { OciService } from 'src/services/oci.service';
import { ToastrImplService } from 'src/services/toastr.service';
import { DocumentsForSendingComponent } from './documents-for-sending/documents-for-sending.component';

@Component({
   selector: 'app-send-document-to-csr-modal',
   templateUrl: './send-document-to-csr-modal.component.html',
   styleUrls: ['./send-document-to-csr-modal.component.scss'],
})
export class SendDocumentToCsrModalComponent implements OnInit {
   displayedColumns: string[] = ['csr', 'numberOfDocuments', 'actions'];
   dataSource = new MatTableDataSource<any>([]);
   isSending = false;
   dataForSendingDocuments: DeliveryRequest = new DeliveryRequest();
   documents: any[];
   centerOptions = [];
   filteredCenterOptions: any = [];

   constructor(
      private dialog: MatDialog,
      @Inject(MAT_DIALOG_DATA) public data: any,
      public dialogRef: MatDialogRef<SendDocumentToCsrModalComponent>,
      private ociService: OciService,
      private codebookService: CodebookService,
      private toastrService: ToastrImplService,
   ) {
      this.dataForSendingDocuments.caseId = data.caseNumber;
      this.dataForSendingDocuments.id = data.caseId;
      this.dataForSendingDocuments.deliveries = [];
      this.ociService.getDocumentsForCaseWithReferenceNumber(data.caseId, false).subscribe((res: any) => {
         this.documents = res;
      });
      this.codebookService.getCsrCodebook().subscribe(result => {
         this.centerOptions = result.sort((a: any, b: any) => a.name.localeCompare(b.name));
         this.filteredCenterOptions = this.centerOptions;
      });
   }

   ngOnInit(): void {}

   addReciverToList() {
      const dialogRefDocs = this.dialog.open(DocumentsForSendingComponent, {
         width: '1000px',
         data: {
            documents: this.documents,
            centers: this.filteredCenterOptions,
         },
      });

      dialogRefDocs.afterClosed().subscribe((result: any) => {
         const { event, data } = result;
         if (event == 'Cancel') {
            return;
         }
         this.dataForSendingDocuments.deliveries.push(data);
         this.dataSource = new MatTableDataSource<any>(this.dataForSendingDocuments.deliveries);
      });
   }

   sendDocument() {
      this.isSending = true;
      this.ociService.sendDocumentToCsr(this.dataForSendingDocuments).subscribe(
         (res: any) => {
            this.isSending = false;
            if (res == true) {
               this.toastrService.success('SENDING-DOCUMENTS.TO_ANOTHER_CSR.SUCCESS');
               this.dialogRef.close({ event: 'Send' });
            } else {
               this.toastrService.error('SENDING-DOCUMENTS.TO_ANOTHER_CSR.FAIL');
            }
         },
         error => {
            this.isSending = false;
            this.toastrService.error('SENDING-DOCUMENTS.TO_ANOTHER_CSR.FAIL');
         },
      );
   }
   closeDialog() {
      this.dialogRef.close({ event: 'Cancel' });
   }
   removeReceiver(index: number) {
      this.dataForSendingDocuments.deliveries.splice(index, 1);
      this.dataSource.data = [...this.dataForSendingDocuments.deliveries];
   }
}
